import { lightTheme } from '@/customTheme'
import { styled } from 'baseui'
import React, { useEffect } from 'react'
import { StyleObject } from 'styletron-standard'

const WrapAutoScroll = styled('div', (props: any) => ({
  boxSizing: 'border-box',
  height: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
  paddingTop:'12px',
  paddingLeft: '24px',
  marginRight: '4px',
  paddingRight: '12px',
  '::-webkit-scrollbar': {
    width: '8px',
    margin: '20px 0',
  },
  '::-webkit-scrollbar-track': {
    borderRadius: '4px',
    marginBottom: props.$scrollThumbMarginBottom ? `${props.$scrollThumbMarginBottom}px` : '0px',
  },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    backgroundColor: lightTheme.colors.grayScale100,
    minHeight: '100px ',
  },
  '::-webkit-scrollbar-thumb:hover': {
    cursor: 'pointer',
    backgroundColor: lightTheme.colors.grayScale150,
  },
  ...props.style,
}))

interface AutoScrollProps {
  style?: StyleObject;
  children?: React.ReactNode;
  handleScroll?: Function;
  initialScrollTop?: number;
  bottomMarginToContent?: boolean | number; // if true, adds 24px margin to the bottom of the content to prevent last item from being too close to the edge
  scrollThumbMarginBottom?: number;
}

const AutoScroll = React.forwardRef<HTMLDivElement, AutoScrollProps>(
  (props, ref) => {

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
      if (props.handleScroll) {
        props.handleScroll(e)
      }
    }

    useEffect(() => {
      if (props.initialScrollTop !== undefined && ref && 'current' in ref && ref.current) {
        setTimeout(() => {
          if (ref && 'current' in ref && ref.current) {
            ref.current.scrollTop = props.initialScrollTop
          }
        }, 1000)
      }
    }, [])

    return (
      <WrapAutoScroll
        $scrollThumbMarginBottom={props.scrollThumbMarginBottom}
        style={{ 
          ...props.style, 
          paddingBottom: typeof props.bottomMarginToContent === 'number' ? `${props.bottomMarginToContent}px` : (props.bottomMarginToContent ? '24px' : '0')
        }}
        onScroll={handleScroll}
        ref={ref}
      >
        {props.children}
      </WrapAutoScroll>
    )
  }
)

export { WrapAutoScroll }
export default AutoScroll
